import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
  Link,
} from "react-router-dom";
import { getCategory, getProvinces, getCity, getRegion } from "./Services";
import Loading from "../../../Common/Loading";
import { useDispatch } from "react-redux";
import Slider from "../../../Common/Slider";
import { BiSearchAlt } from "react-icons/bi";
import { useReserve } from "../../Reserves/Hooks";
import { renderCategoryRoute } from "../../../Common/Function";
import { Color } from "../../../../Utils/styles";
import { FiChevronDown } from "react-icons/fi";

function Search({
  landingLoading,
  renderItem = () => { },
  selected = false,
  isCity = false,
  allcitys = [
    {
      name: "تهران",
      id: 329,
    },
    {
      name: "مشهد",
      id: 491,
    },
    {
      name: "شاهرود",
      id: 634,
    },

    {
      name: "سمنان",
      id: 630,
    },
    {
      name: "نیشابور",
      id: 502,
    },
  ],
}) {
  const dispatch = useDispatch();
  const initialState = {
    loading: true,
    form: {
      provinces: null,
      city: null,
      region: null,
      category: 3,
      title: null,
    },
    data: {
      provinces: null,
      city: null,
      region: null,
      category: 3,
    },
  };
  const [form, setForm] = useState({ category_id: 1 });
  const navigate = useNavigate();
  const [state, setState] = useState(initialState);
  const [placeHolder, setPlaceHolder] = useState("مجموعه");
  const [category, setCategory] = useState([]);
  const [categoryselect, setCategorySelect] = useState(0);
  const handlerProvinces = (data = null) => {
    setState({ ...state, loading: true });
    getProvinces(data).then(result => {
      setState({
        ...state,
        data: { ...state.data, provinces: result },
      });
    });
  };
  const handlerRegion = id => {
    setState({ ...state, loading: true });
    getRegion(id).then(result => {
      setState({
        ...state,
        loading: true,
        data: { ...state.data, region: result },
        form: { city: id, ...state.form },
      });
    });
  };
  const handlerCategory = id => {
    window.$(".loading-page").show();
    getCategory(id).then(result => {
      setCategory(result);
    });
  };
  useEffect(() => {
    handlerCategory();
    dispatch({
      type: "SET",
      payload: { search: { category_id: 1 } },
    });
  }, []);
  useEffect(() => {
    window.$(".loading-page").fadeOut(1000);
  }, [category]);
  const optionsSearch = [
    {
      name: "استخر",
      id: 1,
      img: window.origin + "/WebSide/assets/images/swimming.png",
    },
    {
      name: "سالن بدنسازی",
      id: 2,
      img: window.origin + "/WebSide/assets/images/dumbbell.png",
    },

    {
      name: "سالن فوتسال",
      id: 4,
      img: window.origin + "/WebSide/assets/images/volleyball.png",
    },
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  const renderRoute = () => {
    if (form.category_id) {
      if (form.city_id) {
        return `${renderCategoryRoute(
          selected ? pathname.split("/")[1] : form.category_id
        )["route"]
          }/${allcitys.filter(c => c.id == form.city_id)[0].slug}`;
      } else {
        return `${renderCategoryRoute(
          selected ? pathname.split("/")[1] : form.category_id
        )["route"]
          }`;
      }
    } else {
    }
  };
  const { changePath, pathname } = useReserve();
  const [validate, setValidate] = useState({});

  const renderTo = () => {
    if (selected) {
      if (form.name) {
        if (form.city_id) {
          return `${renderRoute()}?name=${form.name}`;
        } else {
          setValidate({ city_id: true });
        }
      } else {
        return renderRoute();
      }
    } else {
      if (form.name) {
        if (form.city_id) {
          return `${renderRoute()}?name=${form.name}`;
        } else {
          setValidate({ city_id: true });
        }
      } else {
        return renderRoute();
      }
    }
  };
  if (landingLoading) {
    return (
      <section className="first-section  overflow-hidden row align-items-center  background-gray py-1 px-5">
        <div className="container">
          <Loading count={1} height={"400"} />
        </div>
      </section>
    );
  }
  const renderCategory = () => {
    if (selected) {
      return selected;
    }
    if (form.category_id) {
      return form.category_id;
    }

    return "all";
  };
  return (
    <section
      style={{ minHeight: isCity ? "auto" : "62vh" }}
      className="first-section  overflow-hidden row align-items-center  background-gray py-1"
    >
      <div className={`${isCity ? "container-fluid" : "container"}  `}>
        <div className="col-12">
          <Slider
            imageStyle={{
              height: isCity ? "440px" : "540px",
              width: "100%",
              borderRadius: isCity ? "0" : "15px",
              objectFit: "cover",
            }}
          />
          {renderItem()}
          <div className="position-relative search-box-home">
            <div
              style={{
                position: "absolute",
                bottom: "80px",
                zIndex: 2,
                width: "100%",
                maxWidth: "1100px",
                left: "0",
                right: "0",
                margin: "auto",
                padding: "0 10px"
              }}
            >
              <div
                className={`text-details ${window.screen.width > 500 && "my-2"
                  } mb-4`}
              >
                <div className="row">
                  {/* <div className="col-md-2">
                    <button>dwaff</button>
                  </div>
                  <div className="col-md-2"></div> */}
                </div>
                <div className="inner row input-group-search overflow-hidden mx-0 serachInpBox">

                  <div className="col-lg-2 col-md-4 sl_SearchBox">
                    <select
                      style={{
                        objectFit: "fill",
                      }}
                      className="select-search sl_Search"
                      disabled={!category}
                      value={renderCategory()}
                      onChange={e => {
                        if (e) {
                          if (selected) {
                            navigate(changePath(e.target.value));
                          } else {
                            setForm({
                              ...form,
                              category_id: e.target.value,
                            });
                            setPlaceHolder(
                              category
                                .map(cat => {
                                  if (cat.id == e.target.value) {
                                    return cat.name;
                                  }
                                })
                                .filter(Boolean)[0]
                            );
                          }
                        }
                      }}
                    >
                      {category.map((item, key) => (
                        <option
                          className="select-search"
                          key={key}
                          value={item.id}
                        >
                          {item.name}
                        </option>
                      ))}
                    </select>
                    <span className="slDownIcon">
                      <FiChevronDown size={22} />
                    </span>
                  </div>

                  <div className="col-lg-2 col-md-4 sl_SearchBox">
                    <select
                      defaultValue={"all"}
                      className="select-search sl_Search"
                      // style={
                      //   validate.city_id
                      //     ? {
                      //       border: `2px solid ${Color.primary}`,
                      //       borderRadius: "5px",
                      //       color: Color.primary,
                      //       outline: "none",
                      //     }
                      //     : { border: "none", outline: "none" }
                      // }
                      onChange={e => {
                        handlerRegion(e.target.value);
                        setValidate({});
                        setState({
                          ...state,
                          form: {
                            ...state.form,
                            city: e.target.value,
                          },
                        });
                        setForm({
                          ...form,
                          city_id: e.target.value,
                        });
                      }}
                    >
                      <option className="select-search" value={"all"}>
                        همه شهر ها
                      </option>
                      {allcitys.map((item, key) => (
                        <option
                          className="select-search"
                          key={key}
                          value={item.id}
                        >
                          {item.name}
                        </option>
                      ))}
                    </select>
                    <span className="slDownIcon">
                      <FiChevronDown size={22} />
                    </span>
                  </div>

                  <div className="col-lg-2 col-md-4 sl_SearchBox">
                    <select
                      defaultValue={"all"}
                      className="select-search sl_Search"
                      disabled={!state.data.region}
                      onChange={e => {
                        setState({
                          ...state,
                          form: { ...state.form, region: e.target.value },
                        });
                        setForm({ ...form, region: e.target.value });
                      }}
                    >
                      <option className="select-search" value={"all"}>
                        همه مناطق
                      </option>

                      {state &&
                        state.data.region &&
                        state.data.region.map((item, key) => (
                          <option
                            className="select-search"
                            key={key}
                            value={item.id}
                          >
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <span className="slDownIcon">
                      <FiChevronDown size={22} />
                    </span>
                  </div>

                  <div className="col-lg-3 col-md-6 sl_SearchBox">
                    <input
                      type="text"
                      className="input-search inpTxtSearch"
                      placeholder={`عنوان ${placeHolder}`}
                      style={{ fontSize: "16px" }}
                      onChange={e => {
                        setState({
                          ...state,
                          form: { ...state.form, name: e.target.value },
                        });
                        setForm({ ...form, name: e.target.value });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          navigate(renderTo());
                        }
                      }}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6 btnBoxSreach">
                    <button
                      // to={renderTo()}
                      onClick={() => {
                        navigate(renderTo());
                      }}
                      className="btn btn-red btn-search  d-flex justify-content-center align-items-center"
                    >
                      <BiSearchAlt style={{ verticalAlign: "middle" }} />
                      <span style={{ marginRight: "5px", fontSize: "16px" }}>
                        جست و جو
                      </span>
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Search;
